import * as R from 'ramda'
import Vue from 'vue'
import { makeCancellable, takeLatest } from 'vuex-cancellable-actions'

import { apiGet, apiPost } from '../api'

export default { // events for chart
  namespaced: true,
  state: {
    // Типы событий с учетом настроек портала
    // {
    //   'main': {
    //     code: 'main',
    //     name: 'Основные события',
    //     companyId: null,
    //   },
    //   ...
    // }
    map: null,
  },
  getters: {
    sorted: R.pipe(
      R.prop('map'),
      R.unless(R.isNil, R.pipe(
        R.values,
        R.sortBy(R.pipe(R.prop('name'), R.toLower)),
      )),
    ),
  },
  mutations: {
    setMap: (state, { categories }) => {
      state.map = categories.reduce((map, category) => {
        map[category.code] = category
        return map
      }, {})
    },
    set: (state, { category }) => {
      if (!state.map) { throw new Error('no categories loaded') }
      Vue.set(state.map, category.code, category)
    },
  },
  actions: makeCancellable({
    get: takeLatest((
      { state, rootState, commit, dispatch },
      { reload = false } = {},
    ) =>
      !reload && state.map !== null
        ? Promise.resolve()
        : apiGet({ url: `/api/category/list/`, rootState, dispatch })
          .then(({ res: categories }) => commit('setMap', { categories }))
    ),
    add: takeLatest((
      { rootState, commit, dispatch },
      { category: { code, name } },
    ) =>
      apiPost({
        rootState,
        dispatch,
        url: `/api/category/add/`,
        data: { code, name },
      })
        .then(({ res: category }) => {
          dispatch('get', { reload: true })
          commit('set', { category })
        })
    ),
  }),
}
